import React from "react";
import { UserOutlined } from "@ant-design/icons";
import {
  logout,
  useAuthenticationDispatch,
} from "@quest-finance/quest-fe-shared/dist/auth";
import { Avatar, Dropdown } from "antd";
import { MenuProps } from "antd/lib";
import { useNavigate, Link } from "react-router";

const UserNav: React.FunctionComponent = () => {
  const dispatch = useAuthenticationDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    navigate("/auth/login", { replace: true });
    dispatch(logout());
  };

  const menuItems: MenuProps["items"] = [
    {
      key: "0",
      label: <Link to="/iam/profile">Profile</Link>,
    },
    {
      key: "1",
      label: <span onClick={handleLogout}>Logout</span>,
    },
  ];

  return (
    <Dropdown
      menu={{
        items: menuItems,
      }}
      placement="bottom"
      trigger={["click"]}
      getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
      overlayClassName="user-menu"
    >
      <Avatar className="avatar" icon={<UserOutlined />} />
    </Dropdown>
  );
};

export default UserNav;
